export default {"src":"/_next/static/media/ic-tip-gray.cba1c08b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};